import { Clock as ClockIcon } from "lucide-react";

interface OpeningStatusProps {
  isOpen: boolean;
}

export default function OpeningStatus({ isOpen }: OpeningStatusProps) {
  return (
    <div
      className={`mb-2 flex items-center gap-1 text-sm font-normal ${isOpen ? "text-green-700" : "text-red-700"}`}
    >
      <ClockIcon size={14} className="self-center" />
      {isOpen ? "Jetzt geöffnet" : "Jetzt geschlossen"}
    </div>
  );
}
